import { render } from "./Home.vue?vue&type=template&id=a2c5a26c"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script